import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { toast } from 'sonner';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(
        'https://lighthouse-backend-kh53.onrender.com/api/admin/login',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ password }),
        }
      );

      const data = await response.json();

      if (response.ok && data.success) {
        localStorage.setItem('admin_token', data.token);
        toast.success('Login successful!');
        navigate('/admin/dashboard');
      } else {
        toast.error(data.detail || data.message || 'Invalid password');
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg-page)] px-4">
      <div className="max-w-md w-full">
        <div className="bg-[var(--bg-card)] rounded-2xl shadow-lg p-8">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-[var(--accent-purple-200)] rounded-full flex items-center justify-center">
              <Lock size={32} className="text-[var(--text-primary)]" />
            </div>
          </div>

          <h1 className="heading-1 text-center mb-2">Admin Login</h1>
          <p className="body-small text-[var(--text-secondary)] text-center mb-8">
            The Lighthouse Coaching Institute
          </p>

          <form onSubmit={handleLogin}>
            <div className="mb-6">
              <label className="block text-sm font-medium text-[var(--text-primary)] mb-2">
                Admin Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-3 border border-[var(--border-input)] rounded-xl focus:outline-none focus:border-[var(--border-input-focus)] transition-colors bg-white"
                placeholder="Enter admin password"
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full btn-primary"
            >
              {isLoading ? 'Logging in...' : 'Login to Dashboard'}
            </button>
          </form>

          <p className="text-xs text-[var(--text-muted)] text-center mt-6">
            Admin access only
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
